import GlobalOptionsInterface from '../types/global-options'

const defaultGlobalOptions: GlobalOptionsInterface = {
    rootNodeId: '',
    code: '',
    isDemo: false,
}

export default defaultGlobalOptions
